import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, denim, onyxLight, white} from '/theme/color/on.color';
import {blueDark, codGray, mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginVertical: indent * 0.75,
  },
  descriptionText: {
    marginBottom: indent * 0.2,
  },
  link: {
    color: denim,
    fontWeight: '600',
  },
  headerContainer: {
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerText: {
    color: codGray,
    flex: 1,
    fontSize: 16,
    lineHeight: 24,
  },
  sideTextContainer: {
    // marginLeft: 10,
  },
  sideText: {
    marginLeft: 10,
    color: mineShaft,
  },
  AcceleratorBonusContent: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: cloudLight,
    backgroundColor: white,
    padding: 16,
    alignSelf: 'stretch',
    marginRight: 0,
    marginBottom: 15,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  motivationalText: {
    marginVertical: 15,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: indent * 0.5,
  },
  monthText: {
    fontSize: 16,
    lineHeight: 24,
    color: codGray,
  },
  daysLeftText: {
    lineHeight: 24,
    fontWeight: '400',
    marginTop: indent * 0.2,
    marginLeft: indent * 0.25,
    color: onyxLight,
    fontSize: 14,
  },
  pqvHeaderText: {
    marginBottom: indent * 0.25,
    color: onyxLight,
    fontSize: 14,
    lineHeight: 18,
  },
  tierBlock: {
    marginTop: indent * 0.45,
  },
  tierHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tierHeaderRowLargeFont: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  tierTitleText: {
    fontSize: 16,
    lineHeight: 20,
    color: codGray,
  },
  tierAmountText: {
    marginLeft: indent * 0.2,
    color: onyxLight,
    fontSize: 16,
    lineHeight: 20,
    fontWeight: '400',
  },
  tierAmountTextLargeFont: {
    flexShrink: 1,
  },
  tierStatus: {
    marginLeft: 'auto',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tierStatusLargeFont: {
    width: '100%',
    justifyContent: 'flex-end',
    marginLeft: 0,
    marginTop: indent * 0.15,
  },
  tierStatusIcon: {
    color: onyxLight,
    fontSize: 12,
    marginRight: indent * 0.12,
  },
  tierStatusText: {
    color: onyxLight,
    fontSize: 14,
    lineHeight: 18,
    fontWeight: '400',
  },
  tierSlotsRow: {
    flexDirection: 'row',
    marginTop: indent * 0.25,
    width: '100%',
  },
  slot: {
    flex: 1,
    minHeight: 36,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: onyxLight,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
    backgroundColor: white,
    paddingVertical: 4,
  },
  slotLast: {
    marginRight: 0,
  },
  slotFilled: {
    borderStyle: 'solid',
    borderColor: blueDark,
    backgroundColor: blueDark,
  },
  slotFilledContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  slotFilledNumber: {
    color: white,
    fontSize: 14,
    lineHeight: 16,
    marginRight: 2,
    fontWeight: '700',
  },
  slotCheckIcon: {
    color: white,
    fontSize: 10,
  },
  slotPendingNumber: {
    color: onyxLight,
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '700',
  },
});
